import React from 'react';
import { isRoleAdmin, isUserAuditor } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function AdminOrAuditorGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() || isUserAuditor() ? <>{children}</> : <Page403 />;
}
